export default __webpack_public_path__ + "images/FLYTRISTAR.93f8a8f.png";